import { render, staticRenderFns } from "./zhanShi.vue?vue&type=template&id=6a463977&scoped=true&"
import script from "./zhanShi.vue?vue&type=script&lang=js&"
export * from "./zhanShi.vue?vue&type=script&lang=js&"
import style0 from "./zhanShi.vue?vue&type=style&index=0&id=6a463977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a463977",
  null
  
)

export default component.exports